


















































import { Vue, Component } from 'vue-property-decorator';
import { AddElement } from '@/utils/formate';
import {
    addAppID, editAppID, getAppList, deleteApp,
} from '@/api/share';

@Component({})
export default class OPset extends Vue {
    private columnsTable:any = [
        {
            title: 'APP名称',
            key: 'app_name',
            width: 200,
            fixed: 'left',
            align: 'center',
            tooltip: true,
        },
        {
            title: 'APPID',
            width: 340,
            align: 'center',
            canOVerflow: true,
            render: (h:any, i:any) => h('div',
                { style: { display: 'flex', 'align-items': 'center' } },
                [h('div', {}, `${i.row._id}`),
                    h('Gtcopy', {
                        props: {
                            value: i.row._id,
                            id: i.row._id,
                        },
                        style: {
                            marginLeft: '5px',
                        },
                        on: {
                            input: (value:any) => {
                                i.row._id = value;
                            },
                        },
                    })]),
        },
        {
            title: 'KEY',
            key: 'key',
            width: 340,
            align: 'center',
            render: (h:any, i:any) => h('div', { style: { display: 'flex' } }, [
                h('div', `${i.row.hiddenKey ? i.row.key : `${i.row.key.slice(0, 3)}***${i.row.key.slice(-4)}`}`),
                h('div', {
                    style: {
                        display: 'inline-block',
                        minWidth: '22px',
                        minHeight: '18px',
                        marginLeft: '5px',
                        border: '1px solid #d8dde6',
                        borderRadius: '3px',
                        cursor: 'pointer',
                        fontSize: '10px',
                        color: '#d8dde6',
                        padding: '0 3px',
                        lineHeight: '18px',
                    },
                    on: {
                        click: () => {
                            i.row.hiddenKey = !i.row.hiddenKey;
                        },
                    },
                }, `${i.row.hiddenKey ? '隐藏' : '展开'}`),
            ]),
        },
        {
            title: '审核状态',
            key: 'status',
            width: 100,
            render: (h:any, i:any) => h('span', `${i.row.status === 'pass' ? '通过' : '审核中'}`),
        },
        {
            title: '操作',
            width: 200,
            render: (h:any, i:any) => h('div', [
                h('span', {
                    style: { cursor: 'pointer' },
                    on: {
                        click: () => {
                            this.showDialog(true, i.row);
                        },
                    },

                }, '编辑'),
                h('span', {
                    style: { display: 'inline-block', margin: '0 10px', cursor: 'pointer' },
                    on: {
                        click: () => {
                            this.deleteAppInfo(i.row._id);
                        },
                    },
                }, '删除'),
            ]),
        },
    ]

    private appList:any = [];

    private title:String = '新增APP信息';

    private AppNew: Boolean = false;

    private errorMsg: string = '';

    private loading: Boolean = false;

    private page: number = 1;

    private max_page = 1;

    // 判断字符数
    private judgeCount = (rule, value, callback) => {
        // eslint-disable-next-line no-control-regex
        const reallength = value.replace(/[^\x00-\xff]/g, '01').length;
        if (reallength > rule.number) {
            callback(new Error(rule.messages));
        } else {
            callback();
        }
    };

    // 校验URL
    private validateURL = (rule, value, callback) => {
        // eslint-disable-next-line no-useless-escape
        const reg = new RegExp('[a-zA-z]+://[^\s]*');
        const i = value.indexOf('，');
        const enter = value.indexOf('\r');
        const entern = value.indexOf('\n');
        if (i !== -1 || enter !== -1 || entern !== -1) {
            callback(new Error('多个输入请用英文逗号分割'));
        } else {
            if (value.length > 4000) {
                callback(new Error('总长度不能超过4000'));
            }
            let urllist = [];
            try {
                urllist = value.split(',').filter(d => d);
            } catch (error) {
                urllist = value.split(',');
            }
            const lis: any[] = [];
            for (let o = 0; o < urllist.length; o++) {
                const result = reg.test(urllist[o]);
                lis.push(result);
            }
            const wrongUrl = lis.indexOf(false);
            if (wrongUrl !== -1) {
                callback(new Error(rule.message));
            } else {
                callback();
            }
        }
    };

    private ruleValidate:any = {
        app_name: [
            { max: 50, trigger: 'blur', message: '不能超过50个字符' },
            {
                type: 'string', required: true, trigger: 'blur', message: '未识别到有效APP名称信息',
            },
        ],
        origin: [{
            type: 'string', required: true, trigger: 'blur', message: 'origin必填',
        },
        { validator: this.validateURL, trigger: 'blur', message: 'origin格式输入有误' },
        ],
        referer: [{
            type: 'string', required: true, trigger: 'blur', message: 'referer必填',
        },
        { validator: this.validateURL, trigger: 'blur', message: 'referer格式输入有误' },
        ],
    };

    private app:any = {
        app_name: '', origin: '', referer: '', app_type: 1,
    };

    private isDelete: boolean = false;

    private backendMsg: string = '';

    private type: string = 'add';

    // 新增APP按钮
    showDialog(isEdit:Boolean, data:any) {
        this.AppNew = true;
        if (isEdit) {
            this.title = '编辑APP信息';
            this.type = 'edit';
            this.app = Object.assign({}, data);
        } else {
            this.type = 'add';
            this.title = '新增APP信息';
            this.app = Object.assign({}, {
                app_name: '', origin: '', referer: '',
            });
        }
    }

    // 关闭按钮
    cancel() {
        (this.$refs.app as any).resetFields();
    }

    private CurrentType:any = '';


    private currentApp:any = {};

    private PrivateThis:any = this;

    // 新增&编辑 确认按钮
    onSubmit(data:any) {
        (this.$refs.app as any).validate((resp) => {
            if (resp) {
                this.app.product = 'H5本机校验';
                this.app.app_type = 1;
                if (this.type === 'add') {
                    this.appAdd(this.app);
                } else {
                    this.appEdit(this.app);
                }
            }
        });
    }

    // 新增
    appAdd(data: any) {
        addAppID(data).then((res) => {
            if (res.data.status === 1) {
                this.AppNew = false;
                this.PrivateThis.$Gtmessage.success('APP信息添加成功');
                this.getOnePassAPIList();
            } else {
                this.errorMsg = res.data.error_msg;
            }
        });
    }

    // 编辑
    appEdit(data: any) {
        editAppID(data).then((res) => {
            if (res.data.status === 1) {
                this.AppNew = false;
                this.PrivateThis.$Gtmessage.success('APP信息编辑成功');
                this.getOnePassAPIList();
            } else {
                this.errorMsg = res.data.error_msg;
            }
        });
    }

    // 删除app ID 弹出框
    deleteAppInfo(e:string) {
        this.currentApp = e;
        this.isDelete = true;
    }

    // 确认删除
    deleteAppId() {
        deleteApp({ _id: this.currentApp, product: 'H5本机校验' }).then((res) => {
            if (res.data.status === 1) {
                this.isDelete = false;
                this.PrivateThis.$Gtmessage.success('删除成功');
                this.getOnePassAPIList();
            } else {
                this.backendMsg = res.data.error_msg;
            }
        });
    }

    clearError(e:any) {
        this.backendMsg = e;
    }

    //  获取当前用户所有ID List
    getOnePassAPIList() {
        getAppList({ page: this.page, product: 'H5本机校验' }).then((res) => {
            if (res.data.status === 1) {
                this.appList = res.data.data;
                AddElement(this.appList, 'hiddenKey', false);
                this.max_page = res.data.page && res.data.page.max_page;
            } else {
                this.PrivateThis.$Gtmessage.error(res.data.error_msg);
            }
        });
    }

    //
    getMore(e) {
        this.page = e;
        this.getOnePassAPIList();
    }

    created() {
        this.getOnePassAPIList();
    }
}
